;(function($, document, window) {


  /*
   * Variables/Constants
   */
  var VIDEO_SRC_CLASS = 'hasMobile';
  var VIDEO_SRC_ATTR_MOBILE = 'data-mobile';
  var VIDEO_SRC_ATTR_DESKTOP = 'data-desktop';

  var VIDEO_POSTER_CLASS = 'hasMobilePoster';
  var VIDEO_POSTER_ATTR_MOBILE = 'data-mobile-poster';
  var VIDEO_POSTER_ATTR_DESKTOP = 'data-mobile-desktop';

  var VIDEO_MOBILE_BREAKPOINT = 768;

  var $responsiveVideos = $();


  /**
   * Check video sources
   */
  function checkResponsiveVideosSourceAndPoster () {
    $.each($responsiveVideos, function () {
      var isOnMobileDisplay = window.innerWidth <= VIDEO_MOBILE_BREAKPOINT;

      var $video = $(this);
      var $source = $('source', $(this));

      //==============================
      // HANDLE RESPONSIVE SOURCES
      //==============================
      var oldSource = $source.attr('src');
      var newSource = $source.attr(isOnMobileDisplay ? VIDEO_SRC_ATTR_MOBILE : VIDEO_SRC_ATTR_DESKTOP);

      // Source has changed -> reload video
      if (newSource !== oldSource) {
        $source.attr('src', newSource);
        $video.get(0).load();
      }

      //==============================
      // HANDLE RESPONSIVE POSTERS
      //==============================
      var mobilePoster = $source.attr(VIDEO_POSTER_ATTR_MOBILE);
      if ($video.hasClass(VIDEO_POSTER_CLASS) && mobilePoster) {
        // Save original poster in attribute
        if (!$source.attr(VIDEO_POSTER_ATTR_DESKTOP)) {
          $source.attr(VIDEO_POSTER_ATTR_DESKTOP, $video.attr('poster'));
        }

        var desktopPoster = $source.attr(VIDEO_POSTER_ATTR_DESKTOP);

        // Set poster based on display
        $video.attr('poster', isOnMobileDisplay ? mobilePoster : desktopPoster);
      }
    });
  }


  /**
   * On document ready
   */
  $(function () {
    var $allVideos = $('video');

    // Filter for videos using responsive attributes
    $responsiveVideos = $allVideos.filter(function () {
      return $(this).hasClass(VIDEO_SRC_CLASS) && $('source', $(this)).attr(VIDEO_SRC_ATTR_MOBILE);
    });

    $responsiveVideos.each(function () {
      var $src = $('source', $(this));
      $src.attr(VIDEO_SRC_ATTR_DESKTOP, $src.attr('src'));
    });

    /**
     * On window load or resize
     */
    $(window).on('load resize', function () {
      checkResponsiveVideosSourceAndPoster();
    });

    checkResponsiveVideosSourceAndPoster();
  });
  //Showing poster on Safari
  // $.each($('video'), function () {
  //   var $video = $(this);
  //   $video.attr("preload","none");
  // });


})(jQuery, document, window);
